import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDocuments } from "../../hooks/useDocuments";

const DownloadHandler: React.FC = () => {
  const { filename } = useParams<{ filename: string }>();
  const { downloadExport } = useDocuments();

  useEffect(() => {
    const handleDownload = async () => {
      if (!filename) return;

      try {
        const blob = await downloadExport(filename);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = decodeURIComponent(filename);
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();

        // Clean up
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          // Use window.history to go back without a full navigation
          window.history.back();
        }, 100);
      } catch (error) {
        console.error("Download failed:", error);
        window.history.back();
      }
    };

    handleDownload();
  }, [filename, downloadExport]);

  return null;
};

export default DownloadHandler;
